//@ts-nocheck

import React from 'react'

import { Heading, Paragraph } from '../../../atoms/Typography/Typography.component'
import { Col, Row, SpacerBase, Visible } from '../../../atoms/GridSystem'
import Icon from '../../../atoms/Icon/Icon.component'

import * as S from '../Text.styles'

interface TextColumnsProps {
  sectionTitle?: {
    as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
    typo: string
    content: string
  }
  columnLeft?: string
  columnRight?: string
  image?: string
}

const TextColumns: React.FC<TextColumnsProps> = ({ sectionTitle, columnLeft, columnRight, image }) => {
  return (
    <>
      <Row>
        <Col xs={12}>
          <S.Line />
        </Col>
        <Col xs={12} lg={7} $direction="column">
          {sectionTitle ? (
            <>
              <Heading as={sectionTitle.as} typo={sectionTitle.typo} fontPrimary>
                {sectionTitle.content}
              </Heading>
              <SpacerBase xs={1} />
            </>
          ) : null}
        </Col>
      </Row>
      <Row>
        <Visible breakpoints={['xl', 'xxl', 'xxxl']}>
          <Col xs={12} lg={4}>
            {image ? (
              <S.TextColumnsIllustration>
                <Icon name={`illustration-${image.toLowerCase()}`} unlockedProportions />
              </S.TextColumnsIllustration>
            ) : null}
          </Col>
        </Visible>
        <Col xs={12} lg={4} justify="center" $direction="column">
          {columnLeft ? (
            <>
              <SpacerBase xs={3} />
              <Paragraph typo="paragraphLG">
                {columnLeft}
              </Paragraph>
              <SpacerBase xs={3} />
            </>
          ) : null}
        </Col>
        <Col xs={12} lg={4} align="flex-end">
          {columnRight ? (
            <Paragraph typo="paragraphLG">
              {columnRight}
            </Paragraph>
          ) : null}
        </Col>
      </Row>
    </>
  )
}

export default TextColumns
